import React from 'react';
import { useTranslation } from 'react-i18next';
import Chart from 'react-apexcharts';

/**
 * Radial gauge widget — Conversion Rate, etc.
 */
export default function GaugeWidget({ data }) {
    const { t } = useTranslation();
    if (!data?.data) return null;
    const d = data.data;
    const value = d.conversionRate ?? d.rate ?? d.value ?? 0;
    const display = Number(value.toFixed(1));
    const color = value > 5 ? '#10B981' : value > 2 ? '#F59E0B' : '#EF4444';

    const options = {
        chart: { type: 'radialBar', fontFamily: 'Inter, system-ui' },
        plotOptions: {
            radialBar: {
                hollow: { size: '60%' },
                dataLabels: {
                    name: { show: true, fontSize: '10px', color: 'var(--v3-text-muted)', offsetY: 0 },
                    value: { show: true, fontSize: '22px', fontFamily: 'JetBrains Mono, monospace', color: 'var(--v3-text-primary)', formatter: v => `${v}%` },
                },
            },
        },
        colors: [color],
        labels: [t('Conversion')],
        stroke: { lineCap: 'round' },
    };

    return (
        <div style={{ padding: '0 8px 8px', height: '100%' }}>
            <Chart type="radialBar" options={options} series={[display]} height="100%" />
        </div>
    );
}
